import { useTranslation } from "react-i18next"
import { IconCheck, IconX } from "@tabler/icons"
import { showNotification } from "@mantine/notifications"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { postUpdate } from "../../api/postUpdate"
import { queries } from "../../lib/query-key-factory"

type Options = {
  onSuccess?: () => void
}

export const usePostUpdateMutation = (options?: Options) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation(postUpdate, {
    onSuccess: () => {
      showNotification({
        color: "green",
        icon: <IconCheck />,
        title: t("validation.post_edited_success"),
        message: ""
      })

      queryClient.invalidateQueries(queries.posts._def)
      options?.onSuccess?.()
    },
    onError: () => {
      showNotification({
        color: "red",
        icon: <IconX />,
        title: t("root.oops"),
        message: t("error.cant_finalize")
      })
    }
  })
}
